export class ObjectLink{
  link: string;
  label: string;

  constructor(attr: {link?: string, label?: string}) {
    this.link = attr.link;
    this.label = attr.label;
  }
}
